import fieldMetaData from '../../schema/fieldMetaData';

const JournalVatType = {
  type: 'JournalVatType',
  dropdown: {
    valueKey: 'value',
    labelKey: 'label',
    isEnum: true,
  },
  ...fieldMetaData.JournalVatType,
};

export default JournalVatType;
